// extracted by mini-css-extract-plugin
export default {"textBox":"PopUp_textBox__38qSC"};